<template>
  <vs-card>
    <form role="form" @submit.stop.prevent="exportReport">
      <vs-row class="filtroConsolidado">
        <vs-col class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Data Inicial</label>
          <vs-input
            icon="event"
            icon-after
            class="w-full sm:mb-0 mb-3"
            name="Data Inicial"
            id="Data Inicial"
            v-model="filters.initialDate"
            data-testid="auto-report-filter-start-date"
            placeholder="DD/MM/YYYY"
            v-mask="['##/##/####']"
            v-validate="{
              required: true,
              validDate: true,
              isTodayLessOrSameThan: true,
            }"
            :danger="veeErrors.has('Data Inicial')"
            :danger-text="dangerText('Data Inicial')"
          />
        </vs-col>
        <vs-col class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Data Final</label>
          <vs-input
            icon="event"
            icon-after
            class="w-full sm:mb-0 mb-3"
            name="Data Final"
            id="Data Final"
            v-model="filters.finalDate"
            data-testid="auto-report-filter-end-date"
            placeholder="DD/MM/YYYY"
            v-mask="['##/##/####']"
            v-validate="{
              required: true,
              validDate: true,
              isTodayLessOrSameThan: true,
              daysRange: true,
              isEndDateSameOrAfter: true,
            }"
            :danger="veeErrors.has('Data Final')"
            :danger-text="dangerText('Data Final')"
          />
        </vs-col>
        <vs-col v-if="showConvenants" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Tipo de Apólice</label>
          <v-select
            clearable
            v-model="filters.branch"
            :class="
              veeErrors.has('Tipo de Apólice') ? 'w-full has-error' : 'w-full'
            "
            :options="branchs"
            id="Tipo de Apólice"
            name="Tipo de Apólice"
            label="label"
            data-testid="statuses"
            v-validate="{
              required: true,
            }"
            :reduce="(option) => option.id"
          ></v-select>
          <span
            v-show="veeErrors.has('Tipo de Apólice')"
            class="text-danger"
            data-testId="broker-selection-error"
            style="font-size: 0.65rem"
          >
            Campo obrigatório
          </span>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col v-if="showConvenants" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Convênio</label>
          <v-select
            clearable
            multiple
            v-model="filters.covenantIds"
            class="w-full"
            :options="covenantIds"
            id="Status da Apólice"
            label="label"
            data-testid="statuses"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col v-if="showconsultancyIds" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Assessoria</label>
          <v-select
            clearable
            multiple
            v-model="filters.consultancyIds"
            class="w-full"
            :options="consultancyIds"
            id="Status da Apólice"
            label="label"
            data-testid="statuses"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col v-if="showbrokerIds" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Corretora</label>
          <v-select
            clearable
            multiple
            v-model="filters.brokerIds"
            class="w-full"
            :options="brokerIds"
            id="Status da Apólice"
            label="label"
            data-testid="statuses"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row vs-align="flex-end" vs-justify="flex-end" vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <div class="flex justify-end mt-4">
            <vs-button
              color="#038803"
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              vs-w="2"
              class="pt-4 pb-4 mb-4 mt-2 mr-3 sm:mt-0"
              native-type="submit"
              :disabled="isFormValid"
              >Gerar Relatório
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
    </form>
  </vs-card>
</template>
<script>
import vSelect from 'vue-select';
import moment from 'moment';

import reportsApi from '../../../../../services/reports.api';
import functions from '../../../../../utils/functions';
import notify from '../../../../../utils/notify';
import { Validator } from 'vee-validate';
import {
  isDifferenceDays,
  isEndDateGreater,
  isEndDateSameOrAfter,
} from '../../../../../utils/customValidator';

export default {
  name: 'RelatorioParcelasRecebidasFiltro',
  components: {
    vSelect,
  },
  data() {
    const maxDaysRange = 31;
    const brokerIds = [];
    const consultancyIds = [];
    const covenantIds = [];
    const branchs = [];
    const filters = {
      initialDate: '',
      finalDate: '',
      branch: null,
      covenantIds: [],
      brokerIds: [],
      consultancyIds: [],
    };
    const { brokerId, consultancyId, convanantId } =
      functions.getDecoded(localStorage);

    return {
      maxDaysRange,
      branchs,
      brokerIds,
      consultancyIds,
      covenantIds,
      brokerId,
      consultancyId,
      convanantId,
      filters,
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.$validator.validateAll();
      },
    },
  },
  computed: {
    isFullReadingPermission() {
      return this.$can('Leitura Carteira Completa', 'Parcelas Recebidas');
    },
    showbrokerIds() {
      return (
        this.isFullReadingPermission || this.consultancyId || this.convanantId
      );
    },
    showconsultancyIds() {
      return this.isFullReadingPermission || this.convanantId;
    },
    showConvenants() {
      return this.isFullReadingPermission;
    },
    isFormValid() {
      return this.$validator.errors.any();
    },
  },
  created() {
    Validator.extend('daysRange', {
      getMessage: () =>
        `O periodo deve ser de no máximo ${this.maxDaysRange} dias`,
      validate: (value) =>
        isDifferenceDays(this.filters.initialDate, value, this.maxDaysRange),
    });
    Validator.extend('isEndDateSameOrAfter', {
      getMessage: () => `A data final deve ser maior que a data inicial`,
      validate: (value) =>
        isEndDateSameOrAfter(this.filters.initialDate, value),
    });
    Validator.extend('isEndDateGreater', {
      getMessage: () => `A data final deve ser maior que a data inicial`,
      validate: (value) => isEndDateGreater(this.filters.initialDate, value),
    });
  },
  mounted() {
    this.getContext();
  },
  methods: {
    dangerText(field) {
      const errorMessage = this.veeErrors.items.find(
        (item) => item.field === field,
      );

      return errorMessage ? errorMessage.msg : '';
    },
    async getContext() {
      const callGetFullContext = () => reportsApi.getFullContext();
      const callGetUserContext = () => reportsApi.getUserContext();
      const data = this.isFullReadingPermission
        ? await callGetFullContext()
        : await callGetUserContext();
      this.brokerIds = data.brokers;
      this.consultancyIds = data.consultancies;
      this.covenantIds = data.covenants;
      this.branchs = data.policyTypes;
    },
    async exportReport() {
      const isValidFields = await this.$validator.validateAll();

      if (!isValidFields) {
        notify.notifyFail(this.$vs, 'Preencha todos os campos obrigatórios');
        return;
      }

      const start = moment(this.filters.initialDate, 'DD/MM/YYYY').toDate();
      const end = moment(this.filters.finalDate, 'DD/MM/YYYY').toDate();

      const initialDate = start.toISOString().split('T')[0] + 'T00:00:00';
      const finalDate = end.toISOString().split('T')[0] + 'T23:59:59';
      this.$emit('export', {
        ...this.filters,
        initialDate,
        finalDate,
      });
    },
  },
};
</script>
